export default "__VITE_ASSET__b97c52f4__"